import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import { Question } from "src/pods/pairshare/types";
import logEvent from "src/utils/logEvent";

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class PairShareResult extends React.Component<
  {
    question: Question;
    onBack?: () => void;
  },
  never
> {
  componentDidMount() {
    logEvent({
      eventName: "pairshare.result.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "pairshare.result.close",
    });
  }

  render() {
    const { question } = this.props;
    const text: string | undefined = question ? question.text : "";
    return (
      <article sx={pageStyle}>
        <section sx={cardStyle}>
          <div sx={questionStyle}>
            {text &&
              text.split("\n").map((line) => (
                <div key={line} sx={{ margin: RAW_cssValue("1em 0") }}>
                  {line}
                </div>
              ))}
          </div>
        </section>
      </article>
    );
  }

  share = () => {
    const { question, onBack } = this.props;
    if (onBack) {
      onBack();
    }
    logEvent({
      eventName: "ideas.pairshare.save.clicked",
      eventValue: question.storyImageUrl,
    });
  };
}

const pageStyle: ThemeUIStyleObject = {
  fontSize: "28px",
};

const cardStyle: ThemeUIStyleObject = {
  maxWidth: "864px",
  margin: "auto",
  textAlign: "center",
};

const questionStyle: ThemeUIStyleObject = {
  wordWrap: "break-word",
  margin: RAW_cssValue("0 20px"),
};
